const GREEN = '#10b981';
const RED = '#ef4444';
const BLUE = '#38bdf8';
const NEUTRAL = '#a5adba';

const clampScore = value => Math.min(100, Math.max(0, Math.round(value)));

export function getNutritionScorePresentation({ score, totals, targets, calMax, status } = {}) {
  if (score == null || !Number.isFinite(Number(score))) {
    return {
      progress: null,
      color: NEUTRAL,
      background: 'rgba(165, 173, 186, 0.15)',
    };
  }

  const numericScore = Number(score);
  const calorieMax = Number(calMax ?? targets?.calories_max ?? targets?.calories);
  const calories = Number(totals?.calories);
  const isOverTarget = Number.isFinite(calories)
    && Number.isFinite(calorieMax)
    && calorieMax > 0
    && calories > calorieMax;

  if (isOverTarget || status === 'above') {
    return {
      progress: clampScore(numericScore),
      color: RED,
      background: 'rgba(239, 68, 68, 0.2)',
    };
  }

  if (status === 'building' || status === 'below') {
    return {
      progress: clampScore(numericScore),
      color: BLUE,
      background: 'rgba(56, 189, 248, 0.15)',
    };
  }

  if (numericScore >= 80) {
    return {
      progress: clampScore(numericScore),
      color: GREEN,
      background: 'rgba(16, 185, 129, 0.2)',
    };
  }

  return {
    progress: clampScore(numericScore),
    color: BLUE,
    background: 'rgba(56, 189, 248, 0.15)',
  };
}
